module.exports = __webpack_public_path__ + "static/gallery12-3004c4f486a97670124f69760dae1213.jpg";